import {
    appConfig,
    next
} from "../../../utils.js";

export const addForm = ({ form, pageItem, store, attachedItems }) => {
    form.setConfig({
        "title": "Add Form Type",
        "type": "push",
        "location": "Database/DocumentTypes",
        "fields": [{
            "label": "Form Number",
            "name": "FormNumber",
            "type": "text"
        },{
            "label": "Name",
            "name": "Name",
            "type": "text"
        }, {
            "label": "Acronym",
            "name": "NameShort",
            "type": "text"
        }, {
            "label": "Average Time to Complete (hours)",
            "name": "ExpectedTime",
            "type": "text"
        }, {
            "label": "Procedure",
            "name": "ProcedureID",
            "type": "dropdown",
            "labelKey": "Title",
            "idKey": "ID",
            "dataLocation": "Audits/Procedures"
        }, {
            "break": true,
            "divClass": "col-span-3"
        }, {
            "label": "Can be added to Design Changes",
            "divClass": "col-span-3",
            "name": "DesignChanges",
            "type": "checkbox",
            "required": false
        }, {
            "label": "Can be added to Flight Conditions",
            "divClass": "col-span-3",
            "name": "FlightConditions",
            "type": "checkbox",
            "required": false
        }, {
            "label": "Can be added to Repairs",
            "divClass": "col-span-3",
            "name": "Repairs",
            "type": "checkbox",
            "required": false
        }, {
            "label": "Can be added to Documents",
            "divClass": "col-span-3",
            "name": "Documents",
            "type": "checkbox",
            "required": false
        }, {
            "label": "Can be added to Drawings",
            "divClass": "col-span-3",
            "name": "Drawings",
            "type": "checkbox",
            "required": false
        }, {
            "label": "Can be added to DQN's",
            "divClass": "col-span-3",
            "name": "DQNs",
            "type": "checkbox",
            "required": false
        }, {
            "label": "Can be added to Concessions",
            "divClass": "col-span-3",
            "name": "Concessions",
            "type": "checkbox",
            "required": false
        }, {
            "label": "Can be added to DOI's",
            "divClass": "col-span-3",
            "name": "DOIs",
            "type": "checkbox",
            "required": false
        }, {
            "label": "Can be added to Service Bulletins",
            "divClass": "col-span-3",
            "name": "ServiceBulletins",
            "type": "checkbox",
            "required": false
        }, {
            "label": "Requires Upload Status",
            "divClass": "col-span-3",
            "name": "RequiresUploadStatus",
            "type": "checkbox",
            "required": false
        }],
        preSubmitHook() {
            return {
                "Count": 1,
                "Revision": 0,
                "RevisionID": "---0",
                "Revisions": {
                    "---0": {
                        "By": "N/A",
                        "Date": (new Date()).toISOString(),
                        "ID": "---0",
                        "Reason": "Initial Draft",
                        "Revision": 0
                    }
                },
                "SignedoffRequired": false,
                "Standard": {
                    "DesignChanges": false,
                    "FlightConditions": false,
                    "Repairs": false
                }
            }
        }
    });
    form.getDropdownData();
    form.toggle();
};

export const updateForm = ({ form, pageItem }) => {

    form.setValues({
        "FormNumber": pageItem.FormNumber,
        "Name": pageItem.Name,
        "NameShort": pageItem.NameShort,
        "ExpectedTime": pageItem.ExpectedTime,
        "ProcedureID": pageItem.ProcedureID,
        "DesignChanges": pageItem.DesignChanges,
        "FlightConditions": pageItem.FlightConditions,
        "Repairs": pageItem.Repairs,
        "Documents": pageItem.Documents,
        "Drawings": pageItem.Drawings,
        "DQNs": pageItem.DQNs,
        "Concessions": pageItem.Concessions,
        "DOIs": pageItem.DOIs,
        "ServiceBulletins": pageItem.ServiceBulletins,
        "RequiresUploadStatus": pageItem.RequiresUploadStatus
    });

    form.setConfig({
        "title": "Edit Form Type",
        "type": "update",
        "location": `Database/DocumentTypes/${pageItem.ID}`,
        "fields": [{
            "label": "Form Number",
            "name": "FormNumber",
            "type": "text"
        }, {
            "label": "Name",
            "name": "Name",
            "type": "text"
        }, {
            "label": "Acronym",
            "name": "NameShort",
            "type": "text"
        }, {
            "label": "Average Time to Complete (hours)",
            "name": "ExpectedTime",
            "type": "text"
        }, {
            "label": "Procedure",
            "name": "ProcedureID",
            "type": "dropdown",
            "labelKey": "Title",
            "idKey": "ID",
            "dataLocation": "Audits/Procedures"
        }, {
            "break": true,
            "divClass": "col-span-3"
        }, {
            "label": "Can be added to Design Changes",
            "divClass": "col-span-3",
            "name": "DesignChanges",
            "type": "checkbox",
            "required": false
        }, {
            "label": "Can be added to Flight Conditions",
            "divClass": "col-span-3",
            "name": "FlightConditions",
            "type": "checkbox",
            "required": false
        }, {
            "label": "Can be added to Repairs",
            "divClass": "col-span-3",
            "name": "Repairs",
            "type": "checkbox",
            "required": false
        }, {
            "label": "Can be added to Documents",
            "divClass": "col-span-3",
            "name": "Documents",
            "type": "checkbox",
            "required": false
        }, {
            "label": "Can be added to Drawings",
            "divClass": "col-span-3",
            "name": "Drawings",
            "type": "checkbox",
            "required": false
        }, {
            "label": "Can be added to DQN's",
            "divClass": "col-span-3",
            "name": "DQNs",
            "type": "checkbox",
            "required": false
        }, {
            "label": "Can be added to Concessions",
            "divClass": "col-span-3",
            "name": "Concessions",
            "type": "checkbox",
            "required": false
        }, {
            "label": "Can be added to DOI's",
            "divClass": "col-span-3",
            "name": "DOIs",
            "type": "checkbox",
            "required": false
        }, {
            "label": "Can be added to Service Bulletins",
            "divClass": "col-span-3",
            "name": "ServiceBulletins",
            "type": "checkbox",
            "required": false
        }, {
            "label": "Requires Upload Status",
            "divClass": "col-span-3",
            "name": "RequiresUploadStatus",
            "type": "checkbox",
            "required": false
        }],
    });

    form.getDropdownData();
    form.toggle();

};

export const reviseForm = async ({ form, pageItem, store, db }) => {

    // Calculate the next revision
    let nextRevision = next(pageItem.Revision);
    if(nextRevision === undefined) nextRevision = 1;
    let nextRevisionID = `--R${nextRevision}`;

    const mfarQuestions = Object.values(await db.store("Database/MFARQuestions", store));

    const mfarFields = mfarQuestions.map((question) => {
        return {
            "label": question.Question,
            "name": `Revisions[${nextRevisionID}][MFAR][${question.ID}]`,
            "type": "dropdown",
            "dropdownData": [{
                "label": "Yes",
                "id": "Yes"
            }, {
                "label": "N/A",
                "id": "N/A"
            }]
        };
    });

    form.setConfig({
        "title": "Revise Form",
        "description": `Revise Form <strong class="text-primary">${pageItem.Name}</strong> from Revision <strong class="text-primary">${pageItem.Revision || "N/A"}</strong> to Revision <strong class="text-primary">${nextRevision}</strong>.<br />`,
        "location": `Database/DocumentTypes/${pageItem.ID}`,
        "type": "update",
        "fields": [{
            "label": "New Form Template File",
            "name": `Revisions[${nextRevisionID}][File]`,
            "type": "file"
        }, {
            "label": "Database Generatable Form File",
            "name": `Revisions[${nextRevisionID}][GeneratableFile]`,
            "type": "file",
            "required": false
        }, {
            "label": "Sign off Date",
            "name": `Revisions[${nextRevisionID}][Date]`,
            "type": "date"
        }, {
            "label": "Reason",
            "name": `Revisions[${nextRevisionID}][Reason]`,
            "type": "text",
            "divClass": "md:col-span-3"
        }, {
            "label": "MFAR Questions",
            "type": "sectionHeader",
            "divClass": "md:col-span-3"
        }, ...mfarFields],
        async preSubmitHook({ data, files, filesByName, db }) {
            // filesByName is a map from field name to File array
            // Field names end with [File] or [GeneratableFile]
            const fileFieldName = `Revisions[${nextRevisionID}][File]`;
            const generatableFileFieldName = `Revisions[${nextRevisionID}][GeneratableFile]`;
            
            // Upload File (main form template)
            if (filesByName[fileFieldName] && filesByName[fileFieldName].length > 0) {
                await db.upload(`Database/DocumentTypes/${pageItem.ID}/Revisions/${nextRevisionID}`, filesByName[fileFieldName][0]);
                await db.set(`Database/DocumentTypes/${pageItem.ID}/Revisions/${nextRevisionID}/File`, filesByName[fileFieldName][0].name);
            }
            // Upload GeneratableFile (Docxtemplater template) - triggers tag extraction
            if (filesByName[generatableFileFieldName] && filesByName[generatableFileFieldName].length > 0) {
                await db.upload(`Database/DocumentTypes/${pageItem.ID}/Revisions/${nextRevisionID}`, filesByName[generatableFileFieldName][0]);
                await db.set(`Database/DocumentTypes/${pageItem.ID}/Revisions/${nextRevisionID}/GeneratableFile`, filesByName[generatableFileFieldName][0].name);
            }

            return {
                "Revision": nextRevision,
                "RevisionID": nextRevisionID,
                [`Revisions/${nextRevisionID}`]: {
                    "Revision": nextRevision,
                    "By": store.state.user.Basic.name,
                    "ID": nextRevisionID
                }
            }
        }
    });
    form.getDropdownData();
    form.toggle();
};

/**
 * Updates a Form Type revision (DocumentType revision).
 * 
 * Supports uploading two types of templates:
 * - File: Main form template (for display/download)
 * - GeneratableFile: Database-generatable template with Docxtemplater {field} placeholders
 * 
 * Storage contract (issue #3):
 * - Templates stored at: Database/DocumentTypes/{id}/Revisions/{typeRevId}/{filename}
 * - GeneratableFile field stores the filename
 * - See DocumentTypes/TEMPLATING_STORAGE_CONTRACT.md for full details
 * - See documentStoragePaths() in Database/Documents/documentUtils.js for path generation helpers
 */
export const updateFormRevision = ({ form, rowItem, pageItem }) => {
    form.setValues({
        "Date": rowItem.Date,
        "Reason": rowItem.Reason,
        "Number": rowItem.Number
    });
    form.setConfig({
        "title": "Update Revision",
        "type": "update",
        "location": `Database/DocumentTypes/${pageItem.ID}/Revisions/${rowItem.ID}`,
        "fields": [{
            "label": "Sign off Date",
            "name": "Date",
            "type": "date"
        }, {
            "label": "File",
            "name": `Revisions[${rowItem.ID}][File]`,
            "type": "file",
            "required": false
        }, {
            "label": "Database Generatable Form File",
            "name": `Revisions[${rowItem.ID}][GeneratableFile]`,
            "type": "file",
            "required": false
        },{
            "label": "Reason",
            "name": "Reason",
            "type": "text",
            "divClass": "md:col-span-3"
        }],
        async preSubmitHook({ data, newData, files, filesByName, db }) {
            // filesByName is a map from field name to File array
            // Field names end with [File] or [GeneratableFile]
            const fileFieldName = `Revisions[${rowItem.ID}][File]`;
            const generatableFileFieldName = `Revisions[${rowItem.ID}][GeneratableFile]`;
            
            // Upload File (main form template)
            if (filesByName[fileFieldName] && filesByName[fileFieldName].length > 0) {
                await db.upload(`Database/DocumentTypes/${pageItem.ID}/Revisions/${rowItem.ID}`, filesByName[fileFieldName][0]);
                await db.set(`Database/DocumentTypes/${pageItem.ID}/Revisions/${rowItem.ID}/File`, filesByName[fileFieldName][0].name);
            }
            // Upload GeneratableFile (Docxtemplater template) - triggers tag extraction
            if (filesByName[generatableFileFieldName] && filesByName[generatableFileFieldName].length > 0) {
                await db.upload(`Database/DocumentTypes/${pageItem.ID}/Revisions/${rowItem.ID}`, filesByName[generatableFileFieldName][0]);
                await db.set(`Database/DocumentTypes/${pageItem.ID}/Revisions/${rowItem.ID}/GeneratableFile`, filesByName[generatableFileFieldName][0].name);
            }
        }
    });
    form.toggle();
};

export const viewFormRevision = async ({ form, rowItem, db, store }) => {

    const mfarQuestions = Object.values(await db.store("Database/MFARQuestions", store));

    const mfarFields = mfarQuestions.map((question) => {
        return {
            "label": question.Question,
            "name": question.ID,
            "type": "static-value"
        };
    });

    const mfarValueNames = mfarQuestions.map((question) => {
        return question.ID;
    });

    form.setValues({
        "Date": rowItem.Date,
        "Reason": rowItem.Reason,
        "Number": rowItem.Number,
        ...(
            Object.fromEntries(
                mfarValueNames.map(
                    (name) => ([name, rowItem.MFAR[name]])
                )
            )
        )
    });

    form.setConfig({
        "title": `View Revision ${rowItem.Revision}`,
        "type": "view",
        "fields": [{
            "label": "Sign off Date",
            "name": "Date",
            "type": "static-value"
        }, {
            "label": "Reason",
            "name": "Reason",
            "type": "static-value",
            "divClass": "md:col-span-3"
        }, {
            "label": "MFAR Questions",
            "type": "sectionHeader",
            "divClass": "md:col-span-3"
        }, ...mfarFields]
    });
    form.toggle();
};

export const proposeFormTags = ({ rowItem, pageItem, proposeTagsModal, db, store, toast }) => {
    if (appConfig.appPrefix !== "test") {
        toast?.error("Proposed template tags are only available in the test tenant");
        return;
    }

    if (!proposeTagsModal) {
        console.error('[proposeFormTags] proposeTagsModal not available');
        return;
    }
    proposeTagsModal.open({ pageItem, rowItem, db, store, toast });
};

export const cancelForm = ({ pageItem, form }) => {
    form.setConfig({
        "title": "Cancel Form",
        "type": "update",
        "location": `Database/DocumentTypes/${pageItem.ID}`,
        "fields": [],
        preSubmitHook() {
            return {
                "Cancelled": true
            };
        }
    });
    form.toggle();
}
